import { getApiUrl } from '@/lib/api'

/**
 * @param {unknown} err
 * @param {string} fallback
 * @returns {string}
 */
export function apiErrorMessage(err, fallback) {
  const axiosErr = /** @type {{ response?: { data?: { message?: string } }; code?: string; message?: string }} */ (
    err
  )

  if (!axiosErr?.response) {
    const code = axiosErr?.code
    const message = axiosErr?.message ?? ''

    if (
      code === 'ERR_NETWORK' ||
      code === 'ECONNABORTED' ||
      message.includes('Network Error') ||
      message.includes('ERR_CONNECTION_REFUSED')
    ) {
      return `Cannot reach the API server (${getApiUrl()}). Start the backend: php artisan serve --port=8002`
    }

    return fallback
  }

  return axiosErr.response.data?.message ?? fallback
}
